// extracted by mini-css-extract-plugin
export default {"lead":"jNNrrCRaQ7WvS1G1oMki-Lead-lead"};